import { Injectable } from '@angular/core';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { HttpRequestService } from '../../shared/services/http-request.service';
import { GridService } from '../../shared/services/grid.service';
import { MemberUpdateRequestModel } from './member-info.model';
import { ExpireDatesMemberRequestModel } from './member-actions/expiry-dates.model';


@Injectable()
export class MemberManagementService extends GridService {
  url = environment.apiUrl + '/MemberCms/GetMembersDatabase';
  private getMembersDatabaseURL = environment.apiUrl + '/MemberCms/GetMembersDatabase';
  private getMemberInfoURL = environment.apiUrl + '/MemberCms/GetMemberById';
  private getMemberFbDataURL = environment.apiUrl + '/MemberCms/GetMemberFbDataById';
  private getPremiumExpiryDateEnumsURL = environment.apiUrl + '/MemberCms/GetPremiumExpiryDateEnums';
  private postMemberUpdate = environment.apiUrl + '/MemberCms/Update';
  private addInvitesURL = environment.apiUrl + '/MemberCms/AddInvites';
  private updateExpireDatesURL = environment.apiUrl + '/MemberCms/UpdateExpireDates';
  private cancelMembershipURL = environment.apiUrl + '/MemberCms/CancelMembership';
  private getMembersStatisticUrl = environment.apiUrl + '/MemberCms/GetMemberDatabaseAnalytics';
  private getMemberStatisticUrl = environment.apiUrl + '/MemberCms/GetMemberAnalytics';
  private getInvitedByMemberURL = environment.apiUrl + '/MemberCms/GetInvitedByMember';
  private restoreRegistrationEmailURL = environment.apiUrl + '/MemberCms/RestoreRegistrationEmail'


  constructor(private http: HttpRequestService) {
    super();
    this.getData = this.getAllMembers;
  }

  getMembersAnalytics() {
    return this.http.get(this.getMembersStatisticUrl);
  }

  getMemberAnalytic(memberId: number) {
    return this.http.get(this.getMemberStatisticUrl + '?memberId=' + memberId);
  }

  getAllMembers(data) {
    return this.http.post(this.getMembersDatabaseURL, data);
  }

  getMemberProfileInfo(id: number) {

    return this.http.get(this.getMemberInfoURL + '?id=' + id);
  }

  getMemberFbData(id: number) {

    return this.http.get(this.getMemberFbDataURL + '?id=' + id);
  }

  getPremiumExpiryDateEnums() {

    return this.http.get(this.getPremiumExpiryDateEnumsURL);
  }

  memberUpdate(memberPostModel: MemberUpdateRequestModel) {


    return this.http.post(this.postMemberUpdate, memberPostModel);
  }

  addInvites(request) {
    return this.http.post(this.addInvitesURL, request);
  }

  updateExpireDates(request: ExpireDatesMemberRequestModel[]) {
    return this.http.post(this.updateExpireDatesURL, request);
  }
  cancelMembership(request) {
    return this.http.get(this.cancelMembershipURL + '?id=' + request);

  }

  getInvitedByMember(memberId: number) {
    return this.http.get(this.getInvitedByMemberURL + '?id=' + memberId);
  }

  restoreRegistrationEmail(memberId: number) {
    return this.http.get(this.restoreRegistrationEmailURL + '?memberId=' + memberId);
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/member-management/member-management.service.ts